import { useMemo } from 'react';
import { Badge, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { PRIORITY_COLOR, type PlanRow } from '../types';

export function usePreventiveMaintenanceColumns(): ColumnsType<PlanRow> {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () => [
      { title: t('plans.code'), dataIndex: 'code', key: 'code' },
      { title: t('plans.name'), dataIndex: 'name', key: 'name' },
      {
        title: t('plans.priority'),
        dataIndex: 'priority',
        key: 'priority',
        render: (val: string) => (
          <Tag color={PRIORITY_COLOR[val] ?? 'default'}>
            {t(`priority.${val}`)}
          </Tag>
        ),
      },
      {
        title: t('plans.active'),
        dataIndex: 'active',
        key: 'active',
        render: (val: boolean) =>
          val ? (
            <Badge status="success" text={t('common.active')} />
          ) : (
            <Badge status="default" text={t('common.inactive')} />
          ),
      },
      {
        title: t('common.createdAt'),
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (val: string | Date) => new Date(val).toLocaleDateString(),
      },
    ],
    [t],
  );
}
